'use strict';
(function($){
	/*
	 * Vetology.ServerMonitor widget
	 *
	 * @description	This is the main Vetology ServerMonitor widget
	 *
	 * @options		See description for each option
	 *
	 * @method		See description above each method
	 */
	$.widget(
		'Vetology.ServerMonitor',
		{
			"options": {
				"tick": 60000,
				"interval": false,
				"data": {},
				"connecting": false,
				"sqld": {
					"last_hour": [],
					"older": [],
				},
			},
			/*
			 * Vetology.ServerMonitor._init
			 *
			 * @description	Initializes the Vetology.ServerMonitor
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				$("body").Vetology("getCharts", function(){
					google.charts.load('current', {'packages':['corechart']});
					google.charts.setOnLoadCallback(
						function(){
							o._runQuery(true);
							o._loadInterval();
						}
					);
				});
			},

			successCallback: function (response) {
				const o = this;
				o.options.connecting = false;
				$.each(response.servers, function (server, detail) {
					var server_id = server;
					server = $('[data-server="' + server_id + '"]');
					if (!detail) {
						server.find(".last_update").html('<span class="label label-danger">FAILED</span>');
						return true;
					}
					var stats = {
						"ram": 0,
						"swap": 0,
						"cpus": [],
						"hdd": [],
					};
					var stamp = detail.Generation['@attributes'].timestamp;
					var momentDate = moment.unix(stamp);
					var vitals = detail.Vitals['@attributes'];
					var hardware = detail.Hardware['@attributes'];
					var CPU = detail.Hardware.CPU;
					var pci = detail.Hardware.PCI.Device;
					var scsi = detail.Hardware.SCSI.Device;
					var memory = detail.Memory;
					var swap = detail.Memory.Swap["@attributes"];
					var fs = detail.FileSystem.Mount;
					var network = detail.Network.NetDevice;
					var replacements = {
						".last_update": momentDate.format("MM/DD/YYYY HH:mm:ss"),
						".hostname": vitals.Hostname,
						".kernel": vitals.Kernel,
						".ip": vitals.IPAddr,
						".distro": vitals.Distro,
						".uptime": (vitals.Uptime / 3600).toFixed(2) + " hours",
						".current_users": vitals.Users,
						".load_averages": vitals.LoadAvg,
						".processes": vitals.Processes + " (running " + vitals.ProcessesRunning + "/sleeping " + vitals.ProcessesSleeping + ")",
						".cpuid": CPU.CpuCore[0]["@attributes"].Model,
						".cpucount": CPU.CpuCore.length,
						".cpuspeed": CPU.CpuCore[0]["@attributes"].CpuSpeed,
						".cpucache": CPU.CpuCore[0]["@attributes"].Cache,
						".cpuvirt": CPU.CpuCore[0]["@attributes"].Virt,
						".cpubogomips": CPU.CpuCore[0]["@attributes"].Bogomips,
					};
					var ram_total = parseFloat(memory["@attributes"].Total);
					var ram_free = parseFloat(memory["@attributes"].Free);
					var ram_used = parseFloat(memory["@attributes"].Used);
					var ram_percent = parseFloat(memory["@attributes"].Percent);
					stats.ram = ram_percent;
					stats.date = momentDate.format("HH:mm:ss");
					var html = '<div class="progress" style="background-color: rgba(33,33,33,0.3);">';
					html += '<div class="progress-bar progress-bar-';
					if (ram_percent > 85) {
						html += "red";
					} else if (ram_percent > 70) {
						html += "yellow";
					} else {
						html += "green";
					}
					html += '" role="progressbar" aria-valuenow="' + ram_percent + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + ram_percent + '%">';
					html += '<span style="display: block;text-align: left;text-indent: 5px;min-width: 140px;">Used: ' + o._getBytesToHuman(ram_used) + ' of ' + o._getBytesToHuman(ram_total) + '; ' + o._getBytesToHuman(ram_free) + ' free</span>';
					html += "</div>";
					html += "</div>";
					replacements[".ram_stats"] = html;
					ram_total = parseFloat(swap.Total);
					ram_free = parseFloat(swap.Free);
					ram_used = parseFloat(swap.Used);
					ram_percent = parseFloat(swap.Percent);
					stats.swap = ram_percent;
					var html = '<div class="progress" style="background-color: rgba(33,33,33,0.3);">';
					html += '<div class="progress-bar progress-bar-';
					if (ram_percent > 85) {
						html += "red";
					} else if (ram_percent > 70) {
						html += "yellow";
					} else {
						html += "green";
					}
					html += '" role="progressbar" aria-valuenow="' + ram_percent + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + ram_percent + '%">';
					html += '<span style="display: block;text-align: left;text-indent: 5px;min-width: 140px">Used: ' + o._getBytesToHuman(ram_used) + ' of ' + o._getBytesToHuman(ram_total) + '; ' + o._getBytesToHuman(ram_free) + ' free on mount point ' + detail.Memory.Swap.Mount["@attributes"].MountPoint + '</span>';
					html += "</div>";
					html += "</div>";
					replacements[".swap_stats"] = html;
					var processors = [];
					$.each(CPU.CpuCore, function (i, p) {
						var html = '<div class="progress" style="background-color: rgba(33,33,33,0.3);">';
						var load = parseFloat(p["@attributes"].Load);
						stats.cpus.push(load);
						html += '<div class="progress-bar progress-bar-' + (load > 85 ? 'red' : (load > 70 ? 'yellow' : 'green')) + '" role="progressbar" aria-valuenow="' + load + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + load + '%">';
						html += '<span style="display: block;text-align: left;text-indent: 5px;min-width: 140px;">Processor ' + i + ": " + load.toFixed(2) + '%</span>';
						html += "</div>";
						html += "</div>";
						processors.push(html);
					});

					runQueryFinish(replacements, processors, pci, scsi, network, fs, stats, server, server_id, stamp);
				});
				if ($(".mysql").hasClass("hide")) {
					$(".mysql").removeClass("hide");
					var html = '<div class="table-responsive" style="max-height: 300px;overflow-y:scroll">';
					html += '<table class="table table-striped">';
					html += '<body>';
					var count = 0;
					$.each(response.mysql, function (n, v) {
						if (count === 0) {
							html += '<tr>';
						}
						html += '<td class="text-center"><strong>' + v.Variable_name.replace(/_/g, ' ') + '</strong><br>';
						html += '<span class="mysql_' + v.Variable_name + '">' + v.Value + '</span></td>';
						count++;
						if (count === 10) {
							count = 0;
							html += '</tr>';
						}
					});
					html += '</body>';
					html += '</table>';
					html += '</div>';
					$(".mysql").html(html);
				}
				
			},
			/*
			 * Vetology.Vetology._loadInterval
			 *
			 * @description	Starts the interval to get server stats
			 *
			 * @return NULL
			 *
			 */
			"_runQuery": function(init){
				var o = this;
				init = init ? 1 : 0;
				if(o.options.connecting){
					return;
				}
				o.options.connecting = true;
				var servers = $("[data-server]");
				$.ajax(
					{
						url		: "/admin/servers/console/monitor",
						method	: "GET",
						dataType: "JSON",
						data: {
							init: init
						},
						error	: function(){
							o.options.connecting = false;
						},
						success: function (response) {
							o.successCallback(response);

						}
					}
				);
			},

			"runQueryFinish": function (replacements, processors, pci, scsi, network, fs, stats, server, server_id, stamp) {
				replacements[".processors"] = processors.join('<br>');
				var pci_devices = [];
				$.each(pci, function (i, p) {
					pci_devices.push(p["@attributes"].Name);
				});
				replacements[".pci"] = pci_devices.join('<br>');
				var scsi_devices = [];
				$.each(scsi, function (i, p) {
					p = typeof p["@attributes"] != "undefined" ? p["@attributes"] : p;
					scsi_devices.push(p.Name + (p.Capacity ? " " + o._getBytesToHuman(p.Capacity) : ''));
				});
				replacements[".scsi"] = scsi_devices.join('<br>');
				var network_devices = [];
				$.each(network, function (i, n) {
					network_devices.push("Name: " + n.Name + "; Received: " + o._getBytesToHuman(n.RxBytes) + "; Sent: " + o._getBytesToHuman(n.TxBytes) + "; Err: " + n.Err + "; Drops: " + n.Drops + "; Info: " + n.Info);
				});
				replacements[".network"] = network_devices.join('<br>');
				var mounts = ['<div class="row">'];
				$.each(fs, function (i, m) {
					m = m["@attributes"];
					mounts.push('<div class="col-xs-12 col-sm-6 col-md-4">');
					mounts.push("<h4>ID " + m.MountPointID + "</h4>");
					mounts.push("FS Type: " + m.FSType);
					mounts.push("<br>");
					mounts.push("Name: " + m.Name);
					mounts.push("<br>");
					mounts.push("Total: " + o._getBytesToHuman(m.Total));
					mounts.push("<br>");
					mounts.push("Free: " + o._getBytesToHuman(m.Free));
					mounts.push("<br>");
					mounts.push("Used: " + o._getBytesToHuman(m.Used));
					mounts.push("<br>");
					mounts.push("Percent: " + m.Percent);
					mounts.push("<br>");
					mounts.push("Mount Options: " + m.MountOptions);
					mounts.push("<br>");
					mounts.push("Inodes: " + m.Inodes);
					mounts.push("<br>");
					mounts.push("Mount Point: " + m.MountPoint);
					mounts.push("</div>");
					stats.hdd.push(parseFloat(m.Percent));
				});
				mounts.push("</div>");
				replacements[".mount_points"] = mounts.join('');
				$.each(replacements, function (c, r) {
					server.find(c).html(r);
				});
				if (typeof o.options.data[server_id] == "undefined") {
					var id = server.find(".chart_data_cpu").uniqueId().attr("id");
					var id2 = server.find(".chart_data_ram").uniqueId().attr("id");
					var id3 = server.find(".chart_data_hdd").uniqueId().attr("id");
					o.options.data[server_id] = {
						"stats": {},
						"cpu": {
							"chart": new google.visualization.LineChart(document.getElementById(id)),
							"data": new google.visualization.DataTable(),
							"options": {
								title: 'CPU Stats',
								hAxis: {
									format: 'H:m:s'
								}
							}
						},
						"ram": {
							"chart": new google.visualization.LineChart(document.getElementById(id2)),
							"data": new google.visualization.DataTable(),
							"options": {
								title: 'RAM/Swap Stats',
								hAxis: {
									format: 'H:m:s'
								}
							}
						},
						"hdd": {
							"chart": new google.visualization.LineChart(document.getElementById(id3)),
							"data": new google.visualization.DataTable(),
							"options": {
								title: 'HDDs Stats',
								hAxis: {
									format: 'H:m:s'
								}
							}
						},
					};
					o.options.data[server_id].ram.data.addColumn('string', 'Time of Day');
					o.options.data[server_id].ram.data.addColumn('number', 'RAM');
					o.options.data[server_id].ram.data.addColumn('number', 'SWAP');
					o.options.data[server_id].cpu.data.addColumn('string', 'Time of Day');
					$.each(stats.cpus, function (i, cpu) {
						o.options.data[server_id].cpu.data.addColumn('number', 'Core ' + i);
					});
					o.options.data[server_id].hdd.data.addColumn('string', 'Time of Day');
					$.each(stats.hdd, function (i, hdd) {
						o.options.data[server_id].hdd.data.addColumn('number', 'HDD ' + i);
					});
				}
				if (typeof o.options.data[server_id].stats[stamp] == "undefined") {
					o.options.data[server_id].stats[stamp] = true;
					var vals = [stats.date, stats.ram, stats.swap];
					o.options.data[server_id].ram.data.addRow(vals);
					o.options.data[server_id].ram.chart.draw(o.options.data[server_id].ram.data, o.options.data[server_id].ram.options);
					vals = [stats.date];
					$.each(stats.cpus, function (i, cpu) {
						vals.push(cpu);
					});
					o.options.data[server_id].cpu.data.addRow(vals);
					o.options.data[server_id].cpu.chart.draw(o.options.data[server_id].cpu.data, o.options.data[server_id].cpu.options);
					vals = [stats.date];
					$.each(stats.hdd, function (i, hdd) {
						vals.push(hdd);
					});
					o.options.data[server_id].hdd.data.addRow(vals);
					o.options.data[server_id].hdd.chart.draw(o.options.data[server_id].hdd.data, o.options.data[server_id].hdd.options);
				}
			},

			/*
			 * Vetology.Vetology._loadInterval
			 *
			 * @description	Starts the interval to get server stats
			 *
			 * @return NULL
			 *
			 */
			"_loadInterval": function(){
				var o = this;
				clearInterval(o.options.interval);
				o.options.interval = setInterval(
					function(){
						o._runQuery();
					},
					o.options.tick
				);
			},
			"_getBytesToHuman": function(bytes, si){
				var thresh = si ? 1000 : 1024;
				if(Math.abs(bytes) < thresh) {
					return bytes + ' B';
				}
				var units = si
				? ['kB','MB','GB','TB','PB','EB','ZB','YB']
				: ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
				var u = -1;
				do {
					bytes /= thresh;
					++u;
				} while(Math.abs(bytes) >= thresh && u < units.length - 1);
				return bytes.toFixed(1)+' '+units[u];
			}
		}
	);
})(jQuery);

